export function isProfileValid(profile) {
  const isInvalid = !!profile.metadata?.annotations?.inValidReason;

  const hasDeletedPacks = (profile?.spec?.published?.packs || []).some(
    (pack) => pack?.annotations?.system_state === "deleted"
  );
  return !isInvalid && !hasDeletedPacks;
}
